"use strict";

exports.__esModule = true;
exports.ListItems = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _ListItem = require("./ListItem");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var CategorySeparator = _styledComponents["default"].div.withConfig({
  displayName: "ListItems__CategorySeparator",
  componentId: "sc-4dwlcg-0"
})(["position:absolute;left:calc(", " / 2);width:calc(100% - ", ");height:1px;background:#dcdcdc;"], (0, _Theme.val)("CategorySeparatorHorizontalPadding"), (0, _Theme.val)("CategorySeparatorHorizontalPadding"));
var ListItems = exports.ListItems = function ListItems(props) {
  var items = props.items,
    getKey = props.getKey,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? [] : _props$selected;
  var isItemSelected = function isItemSelected(item) {
    var itemKey = getKey(item);
    for (var i = 0; i < selected.length; i++) {
      var selectedItem = selected[i];
      var key = typeof selectedItem === "object" && selectedItem !== null ? getKey(selectedItem) : selectedItem;
      if (key === itemKey) {
        return true;
      }
    }
    return false;
  };
  var rowTemplate = function rowTemplate(item, index) {
    var getKey = props.getKey,
      getItemCategory = props.getItemCategory,
      getCategoryTitle = props.getCategoryTitle;
    var divider;
    if (typeof getItemCategory === "function") {
      var shouldShowDivider = false;
      var category = getItemCategory(item);
      var title = typeof getCategoryTitle === "function" ? getCategoryTitle(category) : category;
      var hasTitle = title != null && title !== "";
      if (index === 0) {
        shouldShowDivider = hasTitle;
      } else {
        var previousItem = items[index - 1];
        shouldShowDivider = getItemCategory(previousItem) !== category;
      }
      if (shouldShowDivider) {
        divider = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, index !== 0 && /*#__PURE__*/_react["default"].createElement(CategorySeparator, null), hasTitle && /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, {
          title: title
        }));
      }
    }
    var isSelected = isItemSelected(item);
    var menuItem = /*#__PURE__*/_react["default"].createElement(_ListItem.ListItem, _extends({
      item: item,
      isSelected: isSelected
    }, props));
    if (divider !== undefined) {
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: getKey(item)
      }, divider, menuItem);
    }
    return menuItem;
  };
  return function (_ref) {
    var index = _ref.index,
      style = _ref.style;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: style
    }, rowTemplate(items[index], index));
  };
};